export default "__VITE_ASSET__oPLlDhq5__"